import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const label = (p) => {
  const [y, m] = p.split("-");
  return new Date(Number(y), Number(m) - 1, 1).toLocaleString("en-IN", { month: "short", year: "2-digit" });
};

export const ApproveMonths = ({ entry, value, onChange }) => {
  const [opts, setOpts] = useState([]);
  useEffect(() => {
    api.get(`/fees/students/${entry.student_id}`).then(({ data }) => {
      const mine = new Set(entry.periods || []);
      setOpts((data.charges || [])
        .filter((c) => /^\d{4}-\d{2}$/.test(c.period || "") && (mine.has(c.period) || (c.status !== "paid" && c.status !== "waived" && c.paid_amount === 0)))
        .map((c) => ({ period: c.period, amount: c.amount }))
        .sort((a, b) => a.period.localeCompare(b.period)));
    }).catch(() => setOpts([]));
  }, [entry.student_id, entry.periods]);
  const sel = new Set(value || []);
  const total = opts.filter((o) => sel.has(o.period)).reduce((s, o) => s + o.amount, 0);
  const toggle = (p) => { const n = new Set(sel); n.has(p) ? n.delete(p) : n.add(p); onChange([...n].sort()); };
  const changed = [...sel].sort().join() !== [...(entry.periods || [])].sort().join();
  return (
    <div className="rounded-lg border border-slate-200 p-3" data-testid="approve-months">
      <p className="text-xs font-semibold text-slate-700">Months paid for — tap to correct</p>
      <div className="flex flex-wrap gap-1.5 mt-2">
        {opts.map((o) => (
          <button key={o.period} type="button" onClick={() => toggle(o.period)} data-testid={`approve-month-${o.period}`}
            className={`px-2.5 py-1 rounded-full text-xs border transition-colors ${sel.has(o.period) ? "bg-blue-900 text-white border-blue-900" : "bg-white text-slate-700 border-slate-300 hover:border-blue-400"}`}>
            {label(o.period)} · ₹{o.amount}
          </button>
        ))}
      </div>
      <p className={`text-[11px] mt-2 ${total === Number(entry.amount) ? "text-slate-500" : "text-red-600 font-semibold"}`} data-testid="approve-months-total">
        Chosen months total ₹{total} · received ₹{entry.amount}{changed ? " · months will be corrected (teacher's entry was " + (entry.periods || []).map(label).join(", ") + ")" : ""}
      </p>
    </div>
  );
};
